import React, { forwardRef } from "react"
import { Group, Layer, Line, Rect, Stage, Text } from "react-konva"
import Konva from "konva"
import { GraphPropContextProvider, useGraphPropContext } from "../GraphPropsContext"
import { GraphRendererProps } from "../Types"

const COLOR_PRESET = ["#d6504d", "#4db7d6", "#abd64d", "#eccc3b"]

const FMatTsiBackground: React.FC = () => {
  const { l } = useGraphPropContext()
  const fontSize = Math.ceil(l * 0.07)
  const l0_2 = Math.ceil(l * 0.2)

  return (
    <Group>
      <Rect x={0} y={0} width={l} height={l} fill="#eeeeee" />
      <Line points={[l0_2, 0, l0_2, l]} stroke="#fff" strokeWidth={1} />
      <Line points={[l0_2 * 2, 0, l0_2 * 2, l]} stroke="#fff" strokeWidth={1} />
      <Line points={[l0_2 * 3, 0, l0_2 * 3, l]} stroke="#fff" strokeWidth={1} />
      <Line points={[l0_2 * 4, 0, l0_2 * 4, l]} stroke="#fff" strokeWidth={1} />
      <Line points={[0, l0_2, l, l0_2]} stroke="#fff" strokeWidth={1} />
      <Line points={[0, l0_2 * 2, l, l0_2 * 2]} stroke="#fff" strokeWidth={1} />
      <Line points={[0, l0_2 * 3, l, l0_2 * 3]} stroke="#fff" strokeWidth={1} />
      <Line points={[0, l0_2 * 4, l, l0_2 * 4]} stroke="#fff" strokeWidth={1} />
      {[1, 2, 3, 4].map((v, i) => (
        <Text
          key={i}
          text={"" + v}
          x={l0_2 * (i + 1)}
          y={fontSize * 0.2}
          offsetX={fontSize * 0.5}
          offsetY={0}
          fill={COLOR_PRESET[i]}
          fontSize={fontSize}
          fontStyle="bold"
          width={fontSize}
          height={fontSize}
          align="center"
          verticalAlign="middle"
        />
      ))}
    </Group>
  )
}

export const FMatTsiRenderer = forwardRef<Konva.Stage, GraphRendererProps>((props, ref) => {
  const { width, children } = props
  return (
    <Stage width={width} height={width} ref={ref}>
      <GraphPropContextProvider width={width}>
        <Layer>
          <FMatTsiBackground />
          {children}
        </Layer>
      </GraphPropContextProvider>
    </Stage>
  )
})
